// extracted by mini-css-extract-plugin
module.exports = {"qt-image-dynamic":"_3e0gt","image16x9":"_2aGgy","image2x1":"_46avO","image4x3":"_1Ewcp","image1x1":"_2VNUu","image":"_2Dafc"};